<oui-button *ngIf="true" type="icon" color="secondary" (click)="onDownload()"><oui-icon>download</oui-icon></oui-button>
<div class="flex-horizontal flex-center justify-center" *ngIf="isLoading">
  <oui-loading size="small"></oui-loading>
</div>
